import styled from 'styled-components'
import { Swiper as SwiperReact } from 'swiper/react'
import { BREAKPOINT_SM } from '../../theme/ota'
import { IcChevronLeft, IcChevronRight } from '../../Icons'

export type ShowButtonsProps = {
  showButtons?: 'desktop' | 'mobile' | 'both' | 'none'
  barNone?: boolean
  isMosaic?: boolean
}

export const Card = styled.div`
  background-color: transparent;
  display: block;
  position: relative;
  width: 100%;
`

export const Swiper = styled(SwiperReact)`
  height: 60px;
  .swiper-button-prev,
  .swiper-button-next {
    background-color: ${({ theme }) => theme?.colors?.textColor};
    border-radius: 50%;
    cursor: pointer;
    display: ${({ showButtons }: ShowButtonsProps) =>
      ['mobile', 'both'].includes(showButtons) || !showButtons ? 'flex' : 'none'};
    height: 30px;
    opacity: 0.7;
    position: absolute;
    top: 45%;
    width: 30px;
    z-index: 3;

    &::after {
      background-color: ${({ theme }) => theme?.colors?.textColor};
      content: '';
    }

    @media (min-width: calc(${BREAKPOINT_SM})) {
      display: ${({ showButtons }) => (['desktop', 'both'].includes(showButtons) ? 'flex' : 'none')};
    }
  }

  .swiper-button-prev {
    background-image: url(${IcChevronLeft});
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-button-next {
    background-image: url(${IcChevronRight});
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    right: 2%;
  }

  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    left: 2%;
  }

  .swiper-slide {
    cursor: pointer;
    height: 100%;
    width: 80px;
  }
`

export const ButtonGallery = styled.div<ShowButtonsProps>`
  align-items: center;
  bottom: 10%;
  background-color: ${({ theme }) => theme?.colors?.textColor};
  border-radius: 2px;
  display: ${({ showButtons }) => (['mobile', 'both'].includes(showButtons) ? 'flex' : 'none')};
  justify-content: center;
  height: ${({ isMosaic }) => (isMosaic ? 'auto' : '25px')};
  opacity: 0.75;
  position: absolute;
  right: ${({ isMosaic }) => (isMosaic ? '15px' : '14px')};
  bottom: 15px;
  width: ${({ isMosaic }) => (isMosaic ? 'fit-content' : '48px')};
  z-index: 1;
  cursor: pointer;
  padding: ${({ isMosaic }) => isMosaic && '10px'};

  img {
    height: 11px;
    opacity: 1;
  }

  p {
    color: ${({ theme }) => theme?.colors?.white};
    font-size: 11px;
    margin: 0;
    margin-left: 7px;
    opacity: 1;
    display: inline;

    @media (max-width: calc(${BREAKPOINT_SM})) {
      font-size: 13px;
    }
  }

  @media (min-width: calc(${BREAKPOINT_SM})) {
    display: ${({ showButtons }) => (['desktop', 'both'].includes(showButtons) ? 'flex' : 'none')};
    bottom: ${({ isMosaic }) =>
      isMosaic ? '20px' : '86px'}; //86px: 60 altura da barra de imagens + 13 do margin-top + 13 para simular padding
    left: ${({ isMosaic }) => isMosaic && '20px'};
    right: ${({ isMosaic }) => isMosaic && ''};
  }
`

export const BigImageContainer = styled.div`
  height: 205px;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    height: 260px;
  }

  @media (min-width: calc(${BREAKPOINT_SM})) {
    height: 352px;
  }
`

export const Image = styled.img`
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    border-radius: 4px;
  }
`

export const Thumb = styled.img`
  border-radius: 4px;
  height: 55px;
  width: 80px;
`

export const Selected = styled.div`
  align-items: center;
  display: block;
  width: 100%;
`

export const Bar = styled.div<ShowButtonsProps>`
  display: none;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    display: ${({ barNone }: ShowButtonsProps) => (barNone ? 'none' : 'block')};
    margin-top: 13px;
  }
`

export const MobileModalContents = styled.div`
  min-height: calc(100vh - 82px);
`
